import type { IdentitySchema } from '@/modules/api-clients/generated';

/**
 * The states Side supports — derived from identity-service's
 * `OperatingUSState` enum so additions/removals there surface as TS errors
 * here. The runtime list is kept in sync via the `Record<>` `satisfies`
 * constraint below: adding a state to the schema breaks the build at the map.
 */
export type SupportedStateCode =
  IdentitySchema.components['schemas']['OperatingUSState'];

const SUPPORTED_STATE_CODES_MAP = {
  AZ: true,
  CA: true,
  CO: true,
  DC: true,
  FL: true,
  GA: true,
  KY: true,
  MA: true,
  MD: true,
  NC: true,
  NJ: true,
  NV: true,
  NY: true,
  OH: true,
  OR: true,
  SC: true,
  TX: true,
  VA: true,
  WA: true,
} satisfies Record<SupportedStateCode, true>;

const SUPPORTED_STATE_CODES = Object.keys(
  SUPPORTED_STATE_CODES_MAP,
) as ReadonlyArray<SupportedStateCode>;

export const isSupportedStateCode = (
  value: string | null | undefined,
): value is SupportedStateCode =>
  value != null && SUPPORTED_STATE_CODES.includes(value as SupportedStateCode);

export const STATE_CODE_TO_NAME: Record<SupportedStateCode, string> = {
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  KY: 'Kentucky',
  MA: 'Massachusetts',
  MD: 'Maryland',
  NC: 'North Carolina',
  NV: 'Nevada',
  NJ: 'New Jersey',
  NY: 'New York',
  OH: 'Ohio',
  OR: 'Oregon',
  SC: 'South Carolina',
  TX: 'Texas',
  VA: 'Virginia',
  WA: 'Washington',
};
